var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStar = function SvgStar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.85 17.825 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425zm3.15.45-4.15 2.5a.9.9 0 0 1-.575.15.97.97 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.437.87.87 0 0 1-.05-.588l1.1-4.725L3.775 11.8a.96.96 0 0 1-.275-1.075q.1-.275.3-.45.2-.176.55-.225l4.85-.425 1.875-4.45q.125-.3.388-.45t.537-.15.537.15.388.45l1.875 4.45 4.85.425q.35.05.55.225t.3.45q.1.274.038.563a.96.96 0 0 1-.313.512l-3.675 3.175 1.1 4.725a.87.87 0 0 1-.05.588q-.125.261-.35.437a.97.97 0 0 1-.525.2.9.9 0 0 1-.575-.15z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };